import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera } from "lucide-react";
import { IMG_PHOTOGRAPHER_LANDING } from "../lib/images";
import { SectionHeading } from "../components/SectionHeading";
import { IconFromKey } from "../lib/iconMap";
import { api } from "../lib/api";

export default function PhotographerLanding() {
  const [benefits, setBenefits] = useState([]);

  useEffect(() => {
    api.get("/content/photographer-benefits").then(({ data }) => setBenefits(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="photographer-landing-page">
      <section className="relative min-h-[560px] flex items-center">
        <div className="absolute inset-0">
          <img src={IMG_PHOTOGRAPHER_LANDING} alt="A photographer with a camera on a forest trail" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-midnight-black via-midnight-black/70 to-midnight-black/30" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-24">
          <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-4">For Photographers</p>
          <h1 className="text-clean-white font-extrabold uppercase tracking-tight text-3xl sm:text-5xl max-w-2xl leading-tight" data-testid="photographer-landing-headline">
            We handle the strangers.
            <br />
            You handle the camera.
          </h1>
          <p className="text-clean-white/80 font-medium max-w-xl mt-6 text-base sm:text-lg">
            Host unforgettable photography experiences, meet new clients, create incredible content and grow your photography business with Stranger Sessions.
          </p>
          <Link to="/signup?role=photographer" data-testid="become-photographer-cta">
            <button className="mt-8 bg-stranger-orange text-clean-white font-bold tracking-widest text-sm px-8 py-4 rounded-full hover:bg-orange-600 transition-colors">
              BECOME A STRANGER SESSIONS PHOTOGRAPHER
            </button>
          </Link>
        </div>
      </section>

      <section className="bg-clean-white py-24">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <SectionHeading eyebrow="Why Photographers Join" title="Everything You Need to Host" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((b) => (
              <div key={b.id} data-testid={`benefit-${b.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <IconFromKey iconKey={b.icon_key} className="w-7 h-7 text-stranger-orange mb-4" />
                <h3 className="font-extrabold uppercase text-sm tracking-wide mb-2">{b.title}</h3>
                <p className="text-sm text-midnight-black/70 font-medium">{b.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-midnight-black py-20 text-center">
        <Camera className="w-10 h-10 text-stranger-orange mx-auto mb-6" />
        <h2 className="text-clean-white font-extrabold uppercase text-2xl sm:text-4xl tracking-tight max-w-2xl mx-auto px-5">Ready to host your first Stranger Session?</h2>
        <Link to="/signup?role=photographer" data-testid="photographer-landing-bottom-cta">
          <button className="mt-8 bg-stranger-orange text-clean-white font-bold tracking-widest text-sm px-8 py-4 rounded-full hover:bg-orange-600 transition-colors">GET STARTED</button>
        </Link>
      </section>
    </div>
  );
}
